<template>
  <div>
    <form @submit.prevent="handleSubmit">
      <b-form-group
        id="questionTextGroup"
        label="Question Text"
        label-for="questionText">
          <b-form-textarea
            id="questionText"
            :state="errors.length == 0 ? null : validateQuestion()"
            placeholder="Enter your question here..."
            v-model.trim="question.text"
            maxLength="400"
            rows="3"
            max-rows="6"
          >
          {{question.text}}
          </b-form-textarea>
          <p
          >{{question.text.length}} / 400 Max Characters </p>
      </b-form-group>
      <b-form-group
        id="questionTypeGroup"
        label="Question Type"
        label-for="questionType">
          <b-form-select id="questionType" v-model="question.type">
            <b-form-select-option value="Multiple Choice (Graded)">Multiple Choice (Graded)</b-form-select-option>
            <b-form-select-option value="Short Answer">Short Answer</b-form-select-option>
          </b-form-select>
      </b-form-group>
      <div v-if="this.isMultiQuestion">
        <b-row
          class="text-left mb-2"
          v-for="answer in question.answerOptions"
          v-bind:key="answer.answerIndex">
          <b-col cols="1" class="text-center font-weight-bold">{{answer.answerIndex}}</b-col>
          <b-col cols="6">
            <b-form-input
              v-model.trim="answer.answerText"
              size="sm"
              maxlength="250"
              :state="errors.length == 0 ? null : validateAnswer(answer.answerText)"
              :placeholder="'Enter an answer for ' +answer.answerIndex">
              {{answer.answerText}}
            </b-form-input>
          </b-col>
          <b-col cols="2"></b-col>
        </b-row>
      </div>
    </form>
    <BaseMessageBlock :messages="errors"></BaseMessageBlock>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EditQuestionForm",
  props: {
    questionId: { type: String, default: null }
  },
  data() {
    return {
      errors: [],
      dataLoaded: true,
      mode: null,
      questionLength: 0,
      waiters: {
        loading: false,
        sending: false
      },
      question: {
        questionId: "",
        text: "",
        sortOrder: 0,
        type: "Multiple Choice (Graded)",
        required: true,
        answerOptions: []
      }
    };
  },
  computed: {
    isMultiQuestion() {
      return this.question.type === "Multiple Choice (Graded)";
    }
  },
  watch: {
    isMultiQuestion(isMulti) {
      this.resetAnswerOptions();
    }
  },
  mounted() {
    if (this.questionId) {
      this.setupEditQuestion();
    } else {
      this.setupNewQuestion();
    }
  },
  methods: {
    setupNewQuestion() {
      this.mode = "Create";
      this.createNewAnswerOptions();
      this.$emit('loaded');
    },
    setupEditQuestion() {
      this.mode = "Edit";
      this.waiters.loading = true;
      axios
        .get(`${this.$api_url}/questions/${this.$route.params.id}`,
          this.getReqConfig()
        )
        .then(response => {
          this.question = response.data;
          if (this.question.answerOptions.length === 0) {
            this.createNewAnswerOptions();
          }
          this.question.answerOptions.sort((a, b) => a.answerIndex > b.answerIndex ? 1 : -1);
        })
        .catch(err => {
          this.errors.push(err);
          this.dataLoaded = false;
        })
        .finally(() => {
          this.waiters.loading = false;
          this.$emit('loaded');
        });
    },
    resetAnswerOptions() {
      this.question.answerOptions.forEach(option => {
        option.answerText = "";
        option.commentRequired = false;
      });
      
    },
    createNewAnswerOptions() {
      this.question.answerOptions = [
        {
          answerIndex: "A",
          answerText: "",
          answerScore: 4,
          commentRequired: false
        },
        {
          answerIndex: "B",
          answerText: "",
          answerScore: 3,
          commentRequired: false
        },
        {
          answerIndex: "C",
          answerText: "",
          answerScore: 2,
          commentRequired: true
        },
        {
          answerIndex: "D",
          answerText: "",
          answerScore: 1,
          commentRequired: true
        },
        {
          answerIndex: "F",
          answerText: "",
          answerScore: 0,
          commentRequired: true
        },
        {
          answerIndex: "NA",
          answerText: "",
          answerScore: -1,
          commentRequired: false
        }
      ];
    },
    validateForm() {
      let formIsValid = true;
      if (!this.validateQuestion()) {
        formIsValid = false;
        this.errors.push({
          message: "Please enter a question 5 or more characters in length."
        });
      }
      if (this.isMultiQuestion) {
        for (let a of this.question.answerOptions) {
          if (!this.validateAnswer(a.answerText)) {
            formIsValid = false;
            this.errors.push({
              message: `Answer '${a.answerIndex}' must be 2 or more characters in length.`
            });
          }
        }
      }
      return formIsValid;
    },
    validateQuestion() {
      this.questionLength = this.question.text.length;
      return this.question.text.length >= 5 && this.question.text.length <= 450;
    },
    validateAnswer(text) {
      return text.length >= 2;
    },
    navigateBackToQuestionList() {
      this.$router.push({
        name: "Evaluation Templates"
      });
    },
    handleSubmit() {
      this.errors = [];
      if (this.validateForm()) {
        if (!this.question.questionId) {
          this.question.questionId = this.$helpers.generateUUID();
        }
        this.question.answerOptions.forEach(ao => {
          if (!ao.answerOptionId) {
            ao.answerOptionId = this.$helpers.generateUUID();
          }
        });

        this.waiters.sending = true;
        axios
          .put(`${this.$api_url}/question-templates/add`, this.question, this.getReqConfig())
          .then(() => {
            if (this.mode != "Edit") {
              this.$router.push({
                name: "Edit Question Template",
                params: { id: this.question.questionId }
              });
            }
            this.$router.go();
          })
          .catch(err => {
            if (err.response && err.response.data) {
              this.errors.push(...err.response.data.map(e => ({message: e})));
            } else {
              this.errors.push(err);
            }
            this.waiters.sending = false;
          });
      } else {
        let message =
          "Some entries are invalid. Please correct these and resubmit.";
        this.errors.push({ message });
      }
    }
  }
};
</script>